import { fromCamelCase, displayAmount } from "../../PayslipHelper";
import { toCamelCase } from "../../../../../Finance/Payroll/helper-payroll/HelperFunction";

const buildPayslipLabelByKey = (accountsTitle) => {
  const map = {};
  if (!Array.isArray(accountsTitle)) return map;

  for (const acc of accountsTitle) {
    const name = acc?.name;
    if (!name) continue;
    const camelKey = toCamelCase(String(name));
    if (!camelKey) continue;
    const label = acc?.payslipLabel;
    if (label) {
      map[camelKey] = label;
    }
  }
  return map;
};

export const _getDeductions = ({ item, styles, accountsTitle }) => {
  const deductions = item?.deductions || [];
  const excludedKeys = new Set(["tax", "2", "5", "10"]);
  const payslipLabelByKey = buildPayslipLabelByKey(accountsTitle);

  return deductions.flatMap((entry, index) => {
    const [rawKey, rawValue] = entry.split(":");
    const key = rawKey?.trim();
    const value = rawValue?.trim();

    if (!key || !value || isNaN(value) || excludedKeys.has(key)) return [];

    const revertedLabel = fromCamelCase(key);
    const displayLabel = payslipLabelByKey[key] ?? revertedLabel;

    return (
      <div style={styles.salaryRowSection} key={index}>
        <div style={styles.salaryRow}>
          <p style={styles.salaryRowLbl}>{displayLabel}</p>
          <p style={styles.amount}>{displayAmount(value)}</p>
        </div>
      </div>
    );
  });
};
